const common = {
  home: 'Trang chủ',
  account: 'Tài khoản',
  logout: 'Đăng xuất',
  fullscreen: 'Toàn màn hình',
  fullscreenExit: 'Thoát toàn màn hình',
  cancel: 'Hủy',
  save: 'Lưu',
  close: 'Đóng',
  loading: 'Đang tải...',
  noData: 'Không có dữ liệu',
  back: 'Quay lại',
  refresh: 'Làm mới',
  time: 'Thời gian',
};

export default common;
